// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.mobile-menu[data-v-1a599a08] {

    display: flex;

    gap: 1rem
}
.mobile-menu__action.icon[data-v-1a599a08] {

    cursor: pointer
}
@media (min-width: 996px) {
.mobile-menu__action.icon[data-v-1a599a08] {

        display: none
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/menus/MobileMenuIcons.vue"],"names":[],"mappings":";AA0CA;;IAAA,aAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA","sourcesContent":["<template>\n  <div class=\"mobile-menu\" @click=\"toggleMenu\">\n    <Icon v-if=\"display\" name=\"close\" class=\"mobile-menu__action\" :size=\"25\" :key=\"display\" />\n    <Icon v-if=\"!display\" name=\"burger\" class=\"mobile-menu__action\" :size=\"32\" :key=\"display\" />\n  </div>\n</template>\n\n<script>\nimport { ref, toRefs, watch } from '@vue/composition-api';\nimport Icon from '@/lego/components/icons/Icon.vue';\n\nexport default {\n  components: {\n    Icon,\n  },\n  props: {\n    value: {\n      type: Boolean,\n      default: false,\n    },\n  },\n  setup(props, { emit }) {\n    const { value } = toRefs(props);\n    const display = ref(value.value);\n\n    watch(value, val => (display.value = val));\n\n    function toggleMenu() {\n      display.value = !display.value;\n      emit('input', display.value);\n    }\n\n    return {\n      display,\n      toggleMenu,\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.mobile-menu {\n  @apply flex gap-xxxs;\n\n  &__action.icon {\n    @apply cursor-pointer lg:hidden;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
